var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "table",
    { staticClass: "table table-striped table-responsive-xl" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.groups, function (item) {
          return _c("tr", [_c("td", [_vm._v(_vm._s(item.title))])])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [_c("tr", [_c("th", [_vm._v("Групи користувача")])])])
  },
]
render._withStripped = true

export { render, staticRenderFns }